import { Cell } from '../components/MapComponent';
import { BlockEntity } from '../entities/BlockEntity';

// types
//-----------------------------------------------------------------------------
export type CollideId =
  // null case
  | 'none'
  // direct attack on block, such as by a rocket
  | 'attack'
  // an immediate neighbor block was destroyed
  | 'block'
  // objective was completed for this block
  | 'complete'
  // the block fell
  | 'fall'
  // a single goal was achieved for this block
  | 'goal'
  // block is tapped by user
  | 'tap';
export type ColliderType =
  | 'block'
  | 'bomb'
  | 'booster'
  | 'rocket'
  | 'cube'
  | 'tap'
  | 'soda';

export type CollideEvent = {
  id: CollideId;
  collider?: Collider;
};

// colliders
//-----------------------------------------------------------------------------
export type TapCollider = { type: 'tap'; cell: Cell };
export type BlockCollider = { type: 'block'; entity: BlockEntity };
export type BombCollider = { type: 'bomb' };
export type RocketCollider = { type: 'rocket' };
export type BoosterCollider = { type: 'booster' };
export type CubeCollider = { type: 'cube' };
export type CubeAllCollider = { type: 'cubeAll' };
export type SodaCollider = { type: 'soda' };
export type LaserBoxCollider = { type: 'laserBox' };
export type Collider =
  | TapCollider
  | BlockCollider
  | BombCollider
  | RocketCollider
  | CubeCollider
  | BoosterCollider
  | CubeAllCollider
  | SodaCollider
  | LaserBoxCollider;

/**
 * Configuration for collider types.
 */
const colliderConfig: {
  power: Collider['type'][];
  oneHitDestroy: Collider['type'][];
} = {
  // List of strong colliders, that should break hard blocks. Other collision can be considered 'soft'.
  power: ['bomb', 'rocket', 'booster', 'cubeAll', 'soda', 'laserBox'],
  // List of one-hit-destroy colliders, that should break blocks with multiple states in one hit.
  oneHitDestroy: ['soda'],
};

// Check if a collider type is a power collider
export function isPowerCollider(type?: Collider['type']) {
  if (!type) return false;
  return colliderConfig.power.includes(type);
}

// Check if a collider type is a one-hit-destroy collider
export function isOneHitCollider(type?: Collider['type']) {
  if (!type) return false;
  return colliderConfig.oneHitDestroy.includes(type);
}
